import {
    FETCH_PLAN_SUBOPTION_LOOKUP_REQUEST,
    FETCH_PLAN_SUBOPTION_LOOKUP_SUCCESS,
    FETCH_PLAN_SUBOPTION_LOOKUP_FAILURE,
  } from "./FetchPlanSubOptionLookupTypes";
  import api from "../../utils/Api";
  
  export const fetchPlanSubOptionLookupRequest = () => {
    return {
      type: FETCH_PLAN_SUBOPTION_LOOKUP_REQUEST,
    };
  };
  
  export const fetchPlanSubOptionLookupSuccess = (planSubOptionLookup) => {
    return {
      type: FETCH_PLAN_SUBOPTION_LOOKUP_SUCCESS,
      payload: planSubOptionLookup,
    };
  };
  
  export const fetchPlanSubOptionLookupFailure = (error) => {
    return {
      type: FETCH_PLAN_SUBOPTION_LOOKUP_FAILURE,
      payload: error,
    };
  };
  
  export const fetchPlanSubOptionLookup = (patient_id) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "medprax/plansuboption/lookup/fetch?patient_id="+patient_id ;

    return async (dispatch) => {
      dispatch(fetchPlanSubOptionLookupRequest);
      try {
        const response = await api.get(
          url,
          {
            headers: headers,
          }
        );
  
        const planSubOptionLookup = response.data.data;
        dispatch(fetchPlanSubOptionLookupSuccess(planSubOptionLookup));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg =  error.response.data && 
        error.response.data.message?error.response.data.message: error.message;
        dispatch(fetchPlanSubOptionLookupFailure(errorMsg));
      }
    };
  };
  